module.exports = __webpack_public_path__ + "img/creative-portfolio.78244ec9.webp";